import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { selectToken } from "../../app/slices/AuthenticationSlice";
import { selectCurrentOrganization } from "../../app/slices/UserSlice";
import { getPropRenderThumbnailCacheKey, selectCachedPropRenderThumbnails, setCachedPropRenderThumbnail } from "../../app/slices/PropLibrarySlice";
import { Prop, PropType } from "../../models/Prop";
import { PropService } from "../../services/PropService";
import { useTranslation } from "react-i18next";

export default function TakeInspectThumbnail({ prop, renderId, tag }: { prop: Prop; renderId?: string; tag: string }) {
  const { t } = useTranslation();
  const token = useSelector(selectToken);
  const organization = useSelector(selectCurrentOrganization);
  const cache = useSelector(selectCachedPropRenderThumbnails) ?? {};
  const dispatch = useDispatch();
  const propType = prop.propType === PropType.Default ? 0 : prop.propType === PropType.Situation ? 1 : undefined;
  const key = propType !== undefined && renderId ? getPropRenderThumbnailCacheKey(propType, prop.propId, renderId) : "";
  const uri = cache[key];
  const [loading, setLoading] = useState(false);
  const [failedUri, setFailedUri] = useState<string>();
  useEffect(() => {
    if (uri || !renderId || propType === undefined || !organization?.id || !token) return;
    let cancelled = false;
    setLoading(true);
    PropService.GetPropRenderThumbnail(organization.id, token, propType, prop.propId, renderId)
      .then((thumbnail) => {
        if (!cancelled && thumbnail?.downloadUri) dispatch(setCachedPropRenderThumbnail({ propType, propId: prop.propId, renderId, downloadUri: thumbnail.downloadUri }));
      })
      .catch(() => { /* A missing preview does not invalidate the Inspect definition. */ })
      .finally(() => { if (!cancelled) setLoading(false); });
    return () => { cancelled = true; };
  }, [uri, renderId, propType, prop.propId, organization?.id, token, dispatch]);
  if (uri && failedUri !== uri) return <img className="w-full h-full min-h-0 object-contain pointer-events-none select-none" src={uri} alt={tag.replace(/_/g, " ")} onError={() => setFailedUri(uri)} />;
  return <p className="text-[12px] text-creator-text-sub" role="status">{loading ? t("take_start_preview_loading", "Loading inspect preview…") : t("take_start_preview_unavailable", "Inspect preview unavailable")}</p>;
}
